const initializeContactPage = () => {
    const contactPage = document.querySelector(".page-template-contact_template");
    if (!contactPage) {
      return;
    }
  
    const buttons = contactPage.querySelectorAll(".contact-page__form-button");
    const select = contactPage.querySelector(".contact-page__form-select");
  
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const selectedFormId = button.dataset.form;
        select.value = selectedFormId;
        toggleForms(selectedFormId);
      });
    });
  
    select.addEventListener("change", (event) => {
      const selectedFormId = event.target.value;
      toggleForms(selectedFormId);
    });
  
    const toggleForms = (selectedFormId) => {
      const formsAndButtons = contactPage.querySelectorAll("[data-form]");
      formsAndButtons.forEach((item) => {
        if (item.dataset.form === selectedFormId) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
    };
  };
  
  if (document.readyState !== "loading") {
    initializeContactPage();
  } else {
    document.addEventListener("DOMContentLoaded", initializeContactPage);
  }